// src/index.js — Unified PWA + Firebase Messaging SW

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { HelmetProvider } from 'react-helmet-async';

// ⚡️ Callback holder for UpdatePrompt or similar in <App />
let setRegistrationCallback = () => {};

const registerServiceWorker = (callback) => {
  setRegistrationCallback = callback;
};

// --- Unified PWA + FCM Service Worker ---
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      // ✅ Register the unified service worker (caching + FCM)
      const registration = await navigator.serviceWorker.register(
        '/firebase-messaging-sw.js',
      );

      console.log('✅ Unified Service Worker registered:', registration.scope);

      // Let <App /> (or UpdatePrompt) know about the registration
      setRegistrationCallback(registration);

      registration.addEventListener('updatefound', () => {
        setRegistrationCallback(registration);
      });
    } catch (error) {
      console.error('❌ Service Worker registration failed:', error);
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <App registerSW={registerServiceWorker} />
  </HelmetProvider>,
);
